import { useState } from 'react';
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react';
import { ChevronDown } from 'lucide-react';
import { useI18n } from '../i18n';
import { countryFlag, countryName, countryOptions } from '../utils/countries';

export default function CountrySelect({ value, onChange, disabled = false }: {
  value: string;
  onChange: (country: string) => void;
  disabled?: boolean;
}) {
  const { t, locale } = useI18n();
  const [query, setQuery] = useState('');
  const options = countryOptions(locale, query);
  return <Combobox value={value} onChange={country => onChange(country || '')} disabled={disabled}
    onClose={() => setQuery('')} immediate>
    <div className="relative">
      <ComboboxInput id="club-country" autoComplete="off"
        defaultValue={value ? `${countryFlag(value)} ${countryName(value, locale)}` : ''}
        displayValue={(country: string) => country ? `${countryFlag(country)} ${countryName(country, locale)}` : ''}
        onChange={event => setQuery(event.target.value)}
        placeholder={t('clubs_management_country_search')}
        className="min-h-11 w-full rounded-lg border border-gray-300 py-2 pl-3 pr-11 focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100" />
      <ComboboxButton className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-gray-500"
        aria-label={t('clubs_management_country')}><ChevronDown size={18} aria-hidden="true" /></ComboboxButton>
    </div>
    <ComboboxOptions anchor="bottom start" modal={false}
      className="z-[60] max-h-64 w-[var(--input-width)] overflow-y-auto rounded-lg border border-gray-200 bg-white p-1 shadow-lg [--anchor-gap:4px] empty:invisible">
      <ComboboxOption value="" className="cursor-pointer rounded px-3 py-2 text-sm text-gray-500 data-[focus]:bg-primary-50">
        {t('clubs_management_country_empty')}
      </ComboboxOption>
      {options.map(country => <ComboboxOption key={country.name} value={country.name}
        className="cursor-pointer rounded px-3 py-2 text-sm text-gray-800 data-[focus]:bg-primary-50 data-[selected]:font-semibold">
        <span aria-hidden="true">{countryFlag(country.name)}</span> {country.label}
      </ComboboxOption>)}
      {options.length === 0 && <div role="status" className="px-3 py-2 text-sm text-gray-500">{t('clubs_management_country_no_results')}</div>}
    </ComboboxOptions>
  </Combobox>;
}
